/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const dateSelectionProps = PropTypes.shape({
    preferred_date: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    division_id: PropTypes.string,
    group_min_size: PropTypes.number,
    group_max_size: PropTypes.number,
    length_of_stay: PropTypes.number,
});
